import { request2 } from '../network/request'
//获取业务招生老师每日工作状态列表页
export function getWorkingStateList (params) {
  return request2({
    url: '/api2/TZsbAdminApi/WorkingState/GetPageList',
    method: 'get',
    params: {
      MemberName: params.memberName,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
    }
  })
}
//添加业务招生老师每日工作状态 
export function addWorkState (data) {
  return request2({
    url: '/api2/TZsbAdminApi/WorkingState/Create',
    method: 'post',
    data: {
      state: data.state,
      memberId: data.memberId
    }
  })
}

// 当前管理员工作状态
export function getAdminWorkState() {
  return request2({
    url: '/api2/TZsbAdminApi/WorkingState/AdminWorkingState',
    method:'get'
  })
}
// 指定管理员工作状态手动切换
export function UpdateWorkingStateById(data) {
  return request2({
    url: '/api2/TZsbAdminApi/WorkingState/UpdateWorkingStateById',
    method:'get',
    params:data
  })
}
// 工作状态枚举列表
export function GetWorkingStateEnumList() {
  return request2({
    url: '/api2/TZsbAdminApi/WorkingState/GetWorkingStateEnumList',
    method:'get'
  })
}